document.addEventListener('DOMContentLoaded', function () {
    console.log('[tooltip.js] DOM loaded');

    var triggers = document.querySelectorAll('.tooltip-trigger');
    console.log('[tooltip.js] Found triggers:', triggers.length);

    triggers.forEach(function (trigger, i) {
        var tooltipId = trigger.getAttribute('data-tooltip-id');
        var tooltipText = document.getElementById(tooltipId);

        console.log(`[tooltip.js] [${i}] Trigger → data-tooltip-id: ${tooltipId}`, tooltipText ? '[OK]' : '[MISSING]');

        if (!tooltipText) return;

        trigger.addEventListener('click', function (event) {
            event.stopPropagation();

            // Confirm click
            console.log(`[tooltip.js] Clicked trigger for ${tooltipId}`);

            var isVisible = window.getComputedStyle(tooltipText).display === 'block';
            hideAllTooltips();

            tooltipText.style.display = isVisible ? 'none' : 'block';
            console.log(`[tooltip.js] ${tooltipId} display = ${tooltipText.style.display}`);
        });
    });

    document.addEventListener('click', function () {
        hideAllTooltips();
    });

    function hideAllTooltips() {
        document.querySelectorAll('.tooltip-text').forEach(function (tooltip) {
            tooltip.style.display = 'none';
        });
    }
});